var render = function render(){
  var _vm$item, _vm$error, _vm$error$validationM;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key, Object.assign({}, _vm.error.validationMessages, {
    package: _vm.$t(`package.type.${_vm.error.validationMessages.package}`)
  }))) + " ")]) : _vm._e(), _c('b-form', {
    staticClass: "w-100",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('form-selector', {
    attrs: {
      "id": "event-project-select",
      "options": _vm.projectOptions,
      "disabled": _vm.isUpdateMode,
      "state": _vm.isUpdateMode ? null : _vm.getState('projectId'),
      "label": _vm.$t('dashboard.events.form.project'),
      "empty-option-text": _vm.isUpdateMode ? (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.projectName : _vm.$t('dashboard.events.placeholder.project')
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.projectId.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('dashboard.events.form.project')
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.projectId.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.projectId, "$model", $$v);
      },
      expression: "$v.formData.projectId.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "id": "event-date",
      "mode": "date",
      "label": _vm.$t('dashboard.events.form.date')
    },
    model: {
      value: _vm.formData.startDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "startDate", $$v);
      },
      expression: "formData.startDate"
    }
  })], 1)], 1), _c('form-input', {
    attrs: {
      "id": "event-name",
      "label": _vm.$t('dashboard.events.form.name'),
      "state": _vm.getState('name'),
      "validation-messages": (_vm$error = _vm.error) === null || _vm$error === void 0 ? void 0 : (_vm$error$validationM = _vm$error.validationMessages) === null || _vm$error$validationM === void 0 ? void 0 : _vm$error$validationM.name,
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.name.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('dashboard.events.form.name')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.name.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('dashboard.events.form.name'),
          max: _vm.$v.formData.name.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.name.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.name, "$model", $$v);
      },
      expression: "$v.formData.name.$model"
    }
  }), _c('b-form-group', {
    attrs: {
      "id": "event-description-group",
      "label": _vm.$t('dashboard.events.form.description'),
      "label-for": "event-description-field"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "event-description-field",
      "rows": "4",
      "state": _vm.getState('description')
    },
    model: {
      value: _vm.formData.description,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "description", $$v);
      },
      expression: "formData.description"
    }
  }), !_vm.$v.formData.description.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
    field: _vm.$t('dashboard.events.form.description'),
    max: _vm.$v.formData.description.$params.maxLength.max
  })) + " ")]) : _vm._e()], 1), _c('label', [_vm._v(_vm._s(_vm.$t('dashboard.events.form.type')))]), _c('event-type-picker', {
    model: {
      value: _vm.formData.type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "type", $$v);
      },
      expression: "formData.type"
    }
  }), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "w-100 btn-back",
    attrs: {
      "variant": "white"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.button.cancel')) + " ")])], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.isUpdateMode ? _vm.$t('dashboard.events.button.submit-update') : _vm.$t('dashboard.events.button.submit')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }